// extracted by mini-css-extract-plugin
module.exports = {"rankings-spacing":"_1e6Woip3SxT1AoWtK3bn","rankings-header":"_3Fsl792P6Fw_JMMVyT8r","actions":"_8TCcIFLJI1mq-BO2Lee9","is-off":"_3bgrAIlKT87NYMgWbIXs"};